module.exports = __webpack_public_path__ + "static/media/aboutus-2.e7f3f7f2.png";